export default __webpack_public_path__ + "b2d37990a4f13dfb8456e4fe844a6a73.svg";